var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel" },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, "is-full-page": true },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _c(
        "div",
        { staticClass: "panel-body" },
        [
          _c("bill-of-lading", {
            attrs: { listLadings: _vm.listLadings, checkValid: _vm.checkValid },
            on: {
              eventAddRow: function($event) {
                return _vm.onAddRow($event)
              },
              eventRemoveRow: function($event) {
                return _vm.onRemoveRow($event)
              }
            }
          }),
          _c("delivery-info", { attrs: { customer: _vm.customerInfo } })
        ],
        1
      ),
      _c("div", { staticClass: "add-deposit-footer" }, [
        _c(
          "div",
          {
            staticClass: "page-footer",
            class: { ml0: !_vm.showMenu, ml220: _vm.showMenu }
          },
          [
            _c("div", { staticClass: "content" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-danger btn-block",
                  attrs: { href: "javascript: void(0)" },
                  on: {
                    click: function($event) {
                      return _vm.submitDeposit()
                    }
                  }
                },
                [_vm._v("Hoàn thành")]
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }